<template>
    <div>
        <h1 style="font-size: 24px; color: black;">投放配置管理</h1>
        <el-card   shadow="never">
            <el-row  type="flex"  align="middle" >
                <el-col :span="6">
                    <span> 投放主体公司： </span>
                    <el-select v-model="queryData.companyId" placeholder="请选择"  >
                        <el-option :key="-1" label="全部" :value = "-1"></el-option>
                        <el-option v-for="(value, key) in companyObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="8">
                        <span > 创建日期：</span>
                        <el-date-picker
                                v-model="queryData.timeDate"
                                type="daterange"
                                :clearable="false"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']"
                                >
                        </el-date-picker>
                </el-col>
            </el-row>
            <el-row  type="flex"  align="middle" >
                <el-col :span="5">
                    <el-button  type="primary" @click="queryList">查询</el-button>
                    <el-button  type="primary" @click="showDetails('创建')">创建</el-button>              
                </el-col>
            </el-row>
        </el-card>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="600px" >
            <el-form :model="editForm" label-width="150px">
                <el-form-item label="投放主体公司:" >
                    <el-select v-model="editForm.companyId" placeholder="请选择">
                        <el-option v-for="(value, key) in companyObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="投放关键词:" >
                    <el-input  style="width: 300px" type="text" v-model="editForm.keyName" ></el-input>
                </el-form-item>
                <el-form-item label="投放媒体:" >
                    <el-select v-model="editForm.mediaId" placeholder="请选择">
                        <el-option v-for="(value, key) in mediaObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="返点:" >
                     <el-input-number style="width: 300px" v-model="editForm.rePoint" :precision="4" :step="0.1" ></el-input-number>
                </el-form-item>
                <el-form-item label="服务点:" >
                    <el-input-number style="width: 300px" v-model="editForm.serverPoint" :precision="4" :step="0.1" ></el-input-number>
                </el-form-item>
                <el-form-item label="开始时间-结束时间:" >
                    <el-date-picker
                            v-model="editForm.dateRange"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :default-time="['00:00:00', '23:59:59']"
                            >
                    </el-date-picker>
                </el-form-item>
<!--                <el-form-item label="操作人:" >-->
<!--                    <el-input  style="width: 300px" type="text" v-model="editForm.operator" ></el-input>-->
<!--                </el-form-item>-->
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirm">确 定</el-button>
                    <el-button type="info" @click="cancel">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <h1>
            <el-table border :data="topicList"  >

                <el-table-column  label="id"  prop="id" ></el-table-column>
                <el-table-column  label="投放主体公司"  prop="companyId" >
                    <template slot-scope="scope">
                        {{scope.row.companyId | commonFilter(companyObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="投放关键词"  prop="keyName" ></el-table-column>
                <el-table-column  label="投放媒体"  prop="mediaId" >
                    <template slot-scope="scope">
                        {{scope.row.mediaId | commonFilter(mediaObj)}}
                    </template>
                </el-table-column>
                <el-table-column  label="返点"  prop="rePoint" ></el-table-column>
                <el-table-column  label="服务点"  prop="serverPoint" ></el-table-column>
                <el-table-column  label="开始时间"  prop="startDt" width="160px" >
                    <template slot-scope="scope">
                        {{ scope.row.startDt | dateFormat }}
                    </template>
                </el-table-column>
                <el-table-column  label="结束时间"  prop="endDt" width="160px">
                    <template slot-scope="scope">
                        {{ scope.row.endDt | dateFormat }}
                    </template>
                </el-table-column>
                <el-table-column  label="创建时间"  prop="createDt" width="160px">
                    <template slot-scope="scope">
                        {{ scope.row.createDt | dateTimeFormat }}
                    </template>
                </el-table-column>
<!--                <el-table-column  label="更新时间"  prop="updateDt" width="160px" :formatter="formatDate"></el-table-column>-->
                <el-table-column  label="操作人"  prop="operator" ></el-table-column>
                <el-table-column  label="操作" align="center">
                    <template slot-scope="scope">
                    <el-button  plain size="mini" type="primary" @click="showDetails('编辑',scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[1,10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
       putInList,
       updatePutInConfig,
    } from "@/http/outApi";
    import settingMix from '@/utils/mix/common-setting'
    export default {
        name: "PutInConfig",
        mixins: [settingMix],
        data(){
           return{
               mediaType: 2, //投放媒体
               needGetCompany: true,
               needGetMedia: true,
               page: {
                   size: 20,
                   page: 1,
                   totalElements: null
               },
               dialogVisible: false,
               dialogTitle :'',
               queryData: {
                   companyId: -1,
                   timeDate: ['', ''],
               },
               queryTrueData: {
                   companyId: '',
                   startDt: null,
                   endDt: null
               },
               editForm: {},
               topicList:[]
           }
        },
        methods :{
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList() ;
            },
            showDetails(title, row) {
                this.editForm = {
                    "id" : null,
                    "companyId" : '',
                    "mediaId" : '',
                    "keyName" :'',
                    "rePoint" :'',
                    "serverPoint" :'',
                    "startDt" :'',
                    "endDt" :'',
                    "operator" :'',
                    "dateRange":['',''],
                };
                this.dialogTitle = title;
                this.dialogVisible = true;
                if(row){
                    this.editForm = {
                        "id" : row.id,
                        "companyId" :row.companyId,
                        "mediaId" :row.mediaId,
                        "keyName" : row.keyName,
                        "rePoint" :row.rePoint,
                        "serverPoint":row.serverPoint,
                        "startDt":row.startDt,
                        "endDt" : row.endDt,
                        "operator" : row.operator,
                        "dateRange":[row.startDt,row.endDt],
                        "createDt" : row.createDt,
                        "updateDt" : row.updateDt
                    };
                }
            },
            confirm(){
                // let _message = '';
                // if(this.editForm.name===''){
                //     _message = '缺少话题内容'
                // }
                // if(_message){
                //     this.$message({
                //         message: _message,
                //         type: 'error'
                //     });
                //     return;
                // }
                this.editForm.startDt = this.editForm.dateRange[0]==='' ? null:this.editForm.dateRange[0];
                this.editForm.endDt = this.editForm.dateRange[1]==='' ? null:this.editForm.dateRange[1];
                updatePutInConfig(this.editForm).then(resp=> {
                    if (resp.data.status===0){
                        this.dialogVisible = false;
                        this.queryList();
                    }
                })
            },
            cancel(){
                this.dialogVisible=false;
            },
            queryList(){
                this.queryTrueData.companyId = this.queryData.companyId;
                this.queryTrueData.startDt = this.queryData.timeDate[0]==='' ? null:this.queryData.timeDate[0];
                this.queryTrueData.endDt = this.queryData.timeDate[1]==='' ? null:this.queryData.timeDate[1];
                this.queryTrueData.size=this.page.size;
                this.queryTrueData.page=this.page.page;
                putInList(this.queryTrueData).then(resp=> {
                    if (resp.data.status===0){
                       this.topicList=resp.data.info.content;
                       this.page.totalElements = resp.data.info.total;
                    }
                })

            },

        },
        created() {
            // this.queryData.timeDate=[new Date(new Date().toLocaleDateString()).getTime(),new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000-1)];
            this.queryList();
        },
    }
</script>

<style scoped>

</style>
